'use client'

import { useCallback } from 'react'

import { sendGTMEvent } from '@b-stock/fe-core/bstock-next/components'
import type { AuctionNavAnalyticsEvent } from '@b-stock/fe-core/bstock-react'

import { useAnalytics } from '@/helpers/telemetry/SegmentAnalytics'

/**
 * Bridges fe-core's `HeaderAuctionNavigation` analytics callback to home-portal's
 * existing Segment + GTM auction-nav events. Preserves the event shape the legacy
 * `HeaderAuctionNavigation` emitted (BP-1938 §8: keep existing auction-nav
 * analytics during the move; new redesign events are deferred to BP-1939).
 *
 * fe-core already normalizes `subsection` with the same regex the legacy code
 * used, so the emitted properties are byte-for-byte compatible.
 */
export function useAuctionNavAnalytics() {
  const { trackButtonClicked } = useAnalytics()

  return useCallback(
    ({ section, subsection, label, href }: AuctionNavAnalyticsEvent) => {
      trackButtonClicked({
        buttonName: 'header_click',
        header_section: section,
        header_subsection: subsection,
        url: document.URL,
        referrer: document.referrer,
        cta_url: href,
      })

      sendGTMEvent({
        event: 'navigation_click',
        nav_section: section,
        nav_text: label,
        nav_url: href,
      })
    },
    [trackButtonClicked]
  )
}
